import { render, staticRenderFns } from "./FolderClosedIcon.vue?vue&type=template&id=25f3c55c&scoped=true"
import script from "./FolderClosedIcon.vue?vue&type=script&lang=js"
export * from "./FolderClosedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3c55c",
  null
  
)

export default component.exports